import thumbnailCover from './thumbnail.png';
import stimuLogo from './stimulogo.png';
import bisaitCover from './bisait.png';
import chhalCover from './chhal.png';
import hariyoparkhalCover from './hariyoparkhal.png';
import mritasaharCover from './mritasahar.png';
import lastwordCover from './lastword.png';
import janmadinCover from './janmadin.png';
import khabarCover from './khabar.png';
import bookCover from './book.png';
import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Stock from './Stock';
import StockSuccess from './StockSuccess';

const ACRONYM = [
  { letter: "S", name: "Smreeti", role: "Inspiration" },
  { letter: "T", name: "Tika", role: "Heart" },
  { letter: "I", name: "Ideas", role: "Innovation" },
  { letter: "M", name: "Mulibir", role: "Drive" },
  { letter: "U", name: "United", role: "Together" },
];

const PRODUCTS = [
  {
    icon: "🛡️",
    img: "/motoguard.png",
    name: "STIMU Motoguard",
    desc: "Protective coverall suit for motorbike riders. Born in Nepal, built for everywhere.",
    tag: "Coming soon",
    tagStyle: { background: "#fef3c7", color: "#92400e" },
    bg: "linear-gradient(135deg,#0d0618,#2d1060)",
    featured: true,
  },
  {
  icon: "📋",
  name: "ListNgo",
  desc: "Pack smarter for every trip. Your travel packing companion on Android.",
  tag: "Try ListNgo",
  link: "https://play.google.com/apps/testing/com.stimu.listngo",
  tagStyle: { background: "#d1fae5", color: "#065f46" },
  bg: "linear-gradient(135deg,#4F46E5,#7C3AED)",
},
  {
    icon: "🧘",
    name: "Mediapp",
    desc: "Track your Meditation progress with diary.",
    tag: "Live on Play Store",
    link: "https://play.google.com/store/apps/details?id=app.stimu.mediapp&pcampaignid=web_share",
    tagStyle: { background: "#ede9fe", color: "#4c1d95" },
    bg: "linear-gradient(135deg,#6d28d9,#a21caf)",
  },
  {
    icon: "📦",
    name: "STIMU Shop",
    desc: "Carefully sourced everyday essentials. Garden, home & outdoor gear.",
    tag: "Amazon & eBay",
    tagStyle: { background: "#e0f2fe", color: "#075985" },
    bg: "linear-gradient(135deg,#0f766e,#0369a1)",
    isShop: true,
    shopItems: [
      
        {
  icon: "🌿",
  name: "STIMU Garden Kneeler",
  desc: "Ergonomic garden kneeler with tote bag.",
  tag: "Live on Amazon & eBay",
  tagStyle: { background: "#fff7e6", color: "#92400e" },
  links: [
    { label: "Buy on Amazon", href: "https://www.amazon.co.uk/dp/B0H6WZBZZN" },
    { label: "Buy on eBay", href: "https://www.ebay.co.uk/itm/298446277852" },
  ],
},
      {
        icon: "☂️",
        name: "BODHI Umbrella",
        desc: "Windproof double-canopy umbrella. Born in Nepal, made for the world.",
        tag: "Coming soon",
        tagStyle: { background: "#fef3c7", color: "#92400e" },
        link: null,
      },
    ],
  },
];
const TESTIMONIALS = [
  {
    quote: '"These are absolutely amazing quality and great value for money this is the 3rd one I\'ve bought because they are made of top quality materials never seen any as good I would highly recommend this seller great company to deal with and so polite and caring"',
    name: "Jackixmas",
    loc: "Verified buyer · UK",
    initials: "YR",
    av: { background: "#d1fae5", color: "#065f46" },
  },
  {
    quote: '"Love the idea of Motoguard — riders here really need something affordable and protective."',
    name: "Andy Nicholes",
    loc: "Beta tester · Nepal",
    initials: "KB",
    av: { background: "#fef3c7", color: "#92400e" },
  },
];

const STATS = [
  { n: "3M+", l: "Riders in Nepal" },
  { n: "NPR 3,000", l: "Target price" },
  { n: "2026", l: "Prototype target" },
];

const CREATIONS = [
 {
    category: "Book · English",
    img: bookCover,
    title: "Echoes of Shouting",
    subtitle: "From Anger to Awareness",
    meta: "Lessons from a Gurkha's Journey to Inner Peace · 2025",
    links: [
      { label: "Kindle £3.04", href: "https://www.amazon.co.uk/dp/B0FRZH12ND" },
      { label: "Paperback £9.89", href: "https://www.amazon.co.uk/dp/B0FRZH12ND" },
    ],
  },
  {
    category: "Novel · Nepali",
    img: mritasaharCover,
    title: "मृत सहर",
    subtitle: "Dead City",
    meta: "नेपाली",
    links: [
      { label: "buy book", href: "YOUR_BOOK_LINK" },
      { label: "Audio on YouTube", href: "https://youtu.be/YxmpYeKDHdk" },
    ],
  },
  {
    category: "Novel · Nepali",
    img: hariyoparkhalCover,
    title: "हरियो पर्खाल",
    subtitle: "Green Wall",
    meta: "नेपाली",
    links: [
      { label: "buy book", href: "YOUR_BOOK_LINK" },
      { label: "Audio on YouTube", href: "https://youtu.be/X23K0elYfJM" },
     ],
  },
  {
    category: "Novel · Nepali",
    img: chhalCover,
    title: "छाल",
    subtitle: "Weave",
    meta: "नेपाली",
    links: [
      { label: "buy book", href: "YOUR_BOOK_LINK" },
      { label: "Audio on YouTube", href: "https://youtu.be/jrmPb4hiY5c" },
     ],
  },
  {
    category: "Novel · Nepali",
    img: bisaitCover,
    title: "बिसाइत",
    subtitle: "Bad Omen",
    meta: "नेपाली",
     links: [
      { label: "buy book", href: "YOUR_BOOK_LINK" },
      { label: "Audio on YouTube", href: "https://youtu.be/qT9h3hoABdc?si=CzwKwfNC0vRwPL2k" },
     ],
  },
  {
    category: "Music · Album",
    img: khabarCover,
    title: "Khabar",
    subtitle: "",
    meta: "by Mulibir Rai",
    links: [
      { label: "Listen now", href: "https://youtu.be/5_mzsM1hBg4" },
      { label: "YouTube", href: "https://youtu.be/5_mzsM1hBg4" },
    ],
  },
  {
    category: "Short Film",
    img: janmadinCover,
    title: "Janmadin.com",
    subtitle: "",
    meta: "",
    links: [
    { label: "Watch on YouTube", href: "https://youtu.be/XBnjeai53sc" },
    { label: "Visit Janmadin.com", href: "https://www.janmadin.com" },
  ],
  },
  {
    category: "Short Film",
    img: lastwordCover,
    title: "The Last Word",
    subtitle: "",
    meta: "",
    links: [{ label: "Watch on YouTube", href: "https://youtu.be/1p94DZ9Tkjg?si=gR5q2qGYMe7kbkS1" }],
  },
  {
  category: "YouTube · Channels",
   img: thumbnailCover,
  title: "Our YouTube Channels",
  subtitle: "",
  meta: "Audio novels, short films & community content",
  links: [
    { label: "Experience Matters", href: "https://www.youtube.com/@Kholakogeet84" },
    { label: "Janmadin Official", href: "https://www.youtube.com/@janmadin130" },
  ],
  },
];

const useInView = (threshold = 0.15) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
};

const FadeIn = ({ children, delay = 0, style = {} }) => {
  const [ref, visible] = useInView();
  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(28px)",
      transition: `opacity 0.65s ease ${delay}s, transform 0.65s ease ${delay}s`,
      ...style,
    }}>
      {children}
    </div>
  );
};

function HomePage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [shopOpen, setShopOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleEmail = (e) => {
    e.preventDefault();
    if (email) { setSubmitted(true); setEmail(""); }
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div style={{ fontFamily: "'Georgia', 'Times New Roman', serif", background: "#0a0612", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Inter:wght@300;400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        .pf { font-family: 'Playfair Display', Georgia, serif; }
        .in { font-family: 'Inter', system-ui, sans-serif; }
        .nav-link { color: rgba(255,255,255,0.55); text-decoration: none; font-size: 13px; font-family: 'Inter', sans-serif; letter-spacing: 0.5px; cursor: pointer; transition: color 0.2s; }
        .nav-link:hover { color: white; }
        .btn-primary { background: linear-gradient(135deg,#4F46E5,#7C3AED,#C026D3); color: white; border: none; padding: 14px 30px; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; font-family: 'Inter', sans-serif; transition: opacity 0.2s, transform 0.2s; }
        .btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }
        .btn-ghost { background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.15); color: white; padding: 14px 30px; border-radius: 12px; font-size: 15px; cursor: pointer; font-family: 'Inter', sans-serif; transition: background 0.2s; }
        .btn-ghost:hover { background: rgba(255,255,255,0.12); }
        .pcard { background: white; border-radius: 16px; padding: 24px; transition: transform 0.25s, box-shadow 0.25s; }
        .pcard:hover { transform: translateY(-4px); box-shadow: 0 20px 40px rgba(0,0,0,0.12); }
        .pcard-featured { outline: 2px solid rgba(124,58,237,0.5); }
        .sacr { display: flex; align-items: center; gap: 14px; background: white; border: 0.5px solid #e5e7eb; border-radius: 10px; padding: 12px 16px; transition: transform 0.2s; }
        .sacr:hover { transform: translateX(4px); }
        .tcard { background: white; border-radius: 16px; padding: 22px; }
        .social-btn { display: flex; align-items: center; gap: 8px; background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 11px 20px; font-size: 13px; color: rgba(255,255,255,0.8); cursor: pointer; text-decoration: none; font-family: 'Inter', sans-serif; transition: background 0.2s; }
        .social-btn:hover { background: rgba(255,255,255,0.13); }
        .email-input { flex: 1; min-width: 200px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15); border-radius: 10px; padding: 13px 18px; color: white; font-size: 14px; outline: none; font-family: 'Inter', sans-serif; transition: border-color 0.2s; }
        .email-input:focus { border-color: rgba(167,139,250,0.6); }
        .email-input::placeholder { color: rgba(255,255,255,0.3); }
        .email-btn { background: linear-gradient(135deg,#f59e0b,#f97316); color: #1a0a00; font-weight: 700; font-size: 14px; padding: 13px 24px; border-radius: 10px; border: none; cursor: pointer; font-family: 'Inter', sans-serif; transition: opacity 0.2s; }
        .email-btn:hover { opacity: 0.9; }
        .footer-link { font-size: 13px; color: rgba(255,255,255,0.4); text-decoration: none; font-family: 'Inter', sans-serif; transition: color 0.2s; cursor: pointer; }
        .footer-link:hover { color: rgba(255,255,255,0.8); }
        .hamburger-btn { display: none !important; }
        @media (max-width: 600px) {
        .products-grid { grid-template-columns: 1fr !important; }
        .story-grid { grid-template-columns: 1fr !important; }
        .tcards { grid-template-columns: 1fr !important; }
        .hero-title { font-size: 48px !important; }
        .nav-desktop { display: none !important; }
        .nepal-stats { gap: 24px !important; }
        .hamburger-btn { display: block !important; }
        .get-in-touch-btn { display: none !important; }
      }
      `}</style>

      {/* NAV */}
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        background: scrolled ? "rgba(10,6,18,0.95)" : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.06)" : "none",
        padding: "16px 32px", display: "flex", alignItems: "center", justifyContent: "space-between",
        transition: "background 0.3s, border 0.3s",
      }}>
      <img src={stimuLogo} alt="STIMU" style={{ height: 36, objectFit: "contain" }} />
        <div className="nav-desktop" style={{ display: "flex", gap: 32 }}>
      {["products", "story", "nepal", "creations", "contact"].map(s => (
              <span key={s} className="nav-link" onClick={() => scrollTo(s)} style={{ textTransform: "capitalize" }}>{s}</span>
          ))}
          <a href="/stock" className="nav-link" style={{ color: "#C9A84C", fontWeight: 500 }}>Stock footage</a>
        </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button className="btn-primary in get-in-touch-btn" style={{ padding: "8px 18px", fontSize: 13, borderRadius: 8 }} onClick={() => scrollTo("contact")}>
          Get in touch
        </button>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            background: "none",
            border: "none",
            color: "white",
            fontSize: 24,
            cursor: "pointer",
            padding: "4px 8px",
          }}
          className="hamburger-btn"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>
      
      </nav>
      {menuOpen && (
  <div style={{
    position: "fixed", top: 60, left: 0, right: 0, zIndex: 99,
    background: "rgba(10,6,18,0.97)", borderBottom: "1px solid rgba(255,255,255,0.08)",
    padding: "16px 24px", display: "flex", flexDirection: "column", gap: 16,
  }}>
    {["products","story","nepal","creations","contact"].map(s => (
      <span key={s} className="nav-link" onClick={() => scrollTo(s)}
        style={{ fontSize: 16, textTransform: "capitalize", padding: "8px 0",
          borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
        {s}
      </span>
    ))}
    <a href="/stock" className="nav-link" style={{ fontSize: 16, padding: "8px 0", color: "#C9A84C", fontWeight: 500 }}>Stock footage</a>
  </div>
)}
{/* HERO */}
<section style={{
  padding: "40px 24px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
  textAlign: "center", position: "relative", overflow: "hidden",
  background: "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(124,58,237,0.18) 0%, transparent 70%), linear-gradient(160deg,#0d0618 0%,#1a0a2e 50%,#0a1628 100%)",
}}>
  <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "32px 32px", pointerEvents: "none" }} />
  <img src={stimuLogo} alt="STIMU" style={{ width: "clamp(300px,60vw,700px)", objectFit: "contain" }} />
</section>
      {/* PRODUCTS */}
      <section id="products" style={{ padding: "88px 24px", background: "#f9f8f" }}>
        <FadeIn>
          <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "3px", color: "#7c3aed", textTransform: "uppercase", textAlign: "center", marginBottom: 8 }}>Our products</div>
          <h2 className="pf" style={{ fontSize: 36, fontWeight: 700, color: "#d9ccf3", textAlign: "center", marginBottom: 8 }}>Made with purpose</h2>
          <p className="in" style={{ fontSize: 15, color: "rgba(255,255,255,0.5)", textAlign: "center", marginBottom: 48, maxWidth: 400, margin: "0 auto 48px" }}>From the roads of Nepal to your daily routine</p>
        </FadeIn>
        <div className="products-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20, maxWidth: "860px", margin: "0 auto" }}>
          {PRODUCTS.map((p, i) => (
  <FadeIn key={i} delay={i * 0.1}>
    <div
      className={`pcard${p.featured ? " pcard-featured" : ""}`}
      style={p.isShop ? { cursor: "pointer" } : {}}
      onClick={p.isShop ? () => setShopOpen(true) : undefined}
    >
      <div style={{ width: 52, height: 52, borderRadius: 14, background: p.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, marginBottom: 16, overflow: "hidden" }}>
        {p.img ? <img src={p.img} alt={p.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : p.icon}
      </div>
      <div className="pf" style={{ fontSize: 17, fontWeight: 700, color: "#0a0612", marginBottom: 8 }}>{p.name}</div>
      <div className="in" style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.65, marginBottom: 14 }}>{p.desc}</div>
{p.link ? (
        <a href={p.link}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="in"
          style={{ ...p.tagStyle, fontSize: 10, padding: "3px 10px", borderRadius: 6, fontWeight: 600, textDecoration: "none", display: "inline-block" }}
        >
          {p.tag}
        </a>
      ) : (
        <span className="in" style={{ ...p.tagStyle, fontSize: 10, padding: "3px 10px", borderRadius: 6, fontWeight: 600 }}>{p.tag}</span>
      )}
      {p.isShop && <div className="in" style={{ fontSize: 11, color: "#7c3aed", marginTop: 10 }}>Tap to browse products →</div>}
    </div>
  </FadeIn>
))}
        </div>
      </section>

      {/* STORY */}
      <section id="story" style={{ padding: "88px 24px", background: "#0a0612" }}>
        <FadeIn>
          <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "3px", color: "#a78bfa", textTransform: "uppercase", textAlign: "center", marginBottom: 8 }}>Our story</div>
          <h2 className="pf" style={{ fontSize: 36, fontWeight: 700, color: "white", textAlign: "center", marginBottom: 8 }}>A family name behind every product</h2>
          <p className="in" style={{ fontSize: 15, color: "rgba(255,255,255,0.45)", textAlign: "center", marginBottom: 56, maxWidth: 420, margin: "0 auto 56px" }}>STIMU isn't just a brand — it's personal</p>
        </FadeIn>
        <div className="story-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, maxWidth: "760px", margin: "0 auto", alignItems: "start" }}>
          <FadeIn delay={0.1}>
            <p className="in" style={{ fontSize: 15, color: "rgba(255,255,255,0.6)", lineHeight: 1.8, marginBottom: 16 }}>
              The name STIMU is built from the people who matter most — family members whose initials form every letter. That means every product carries something real: a reason to get it right.
            </p>
            <p className="in" style={{ fontSize: 15, color: "rgba(255,255,255,0.6)", lineHeight: 1.8 }}>
              From an idea sparked riding motorbikes through Nepal, to an app helping travellers pack smarter, STIMU is about building things that genuinely help people.
            </p>
          </FadeIn>
          <FadeIn delay={0.2}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {ACRONYM.map((a, i) => (
                <div key={i} className="sacr">
                  <div className="pf" style={{ fontSize: 22, fontWeight: 700, color: "#f59e0b", width: 24, textAlign: "center", flexShrink: 0 }}>{a.letter}</div>
                  <div>
                    <div className="in" style={{ fontSize: 14, fontWeight: 500, color: "#0a0612" }}>{a.name}</div>
                    <div className="in" style={{ fontSize: 11, color: "#9ca3af" }}>{a.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* NEPAL */}
      <section id="nepal" style={{ padding: "88px 24px", background: "linear-gradient(160deg,#0d0618,#0a1628)", textAlign: "center" }}>
        <FadeIn>
          <div style={{ fontSize: 48, marginBottom: 20 }}>🇳🇵</div>
          <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "3px", color: "#a78bfa", textTransform: "uppercase", marginBottom: 12 }}>Rooted in Nepal</div>
          <h2 className="pf" style={{ fontSize: 36, fontWeight: 700, color: "white", marginBottom: 16 }}>Where the idea was born</h2>
          <p className="in" style={{ fontSize: 15, color: "rgba(255,255,255,0.5)", lineHeight: 1.8, maxWidth: 520, margin: "0 auto 48px" }}>
            The idea for STIMU Motoguard came from personal experience riding motorbikes through Nepal — where millions ride daily with little protection. We're going back to prototype, test, and build something that could genuinely save lives.
          </p>
          <div className="nepal-stats" style={{ display: "flex", justifyContent: "center", gap: 56, flexWrap: "wrap" }}>
            {STATS.map((s, i) => (
              <FadeIn key={i} delay={i * 0.1}>
                <div>
                  <div className="pf" style={{ fontSize: 32, fontWeight: 700, color: "#a78bfa" }}>{s.n}</div>
                  <div className="in" style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginTop: 4, letterSpacing: "0.5px" }}>{s.l}</div>
                </div>
              </FadeIn>
            ))}
          </div>
        </FadeIn>
      </section>

      {/* CREATIONS */}
<section id="creations" style={{ padding: "88px 24px", background: "#0a0612" }}>
  <FadeIn>
    <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "3px", color: "#a78bfa", textTransform: "uppercase", textAlign: "center", marginBottom: 8 }}>By Mulibir Rai</div>
    <h2 className="pf" style={{ fontSize: 36, fontWeight: 700, color: "white", textAlign: "center", marginBottom: 8 }}>Creations</h2>
    <p className="in" style={{ fontSize: 15, color: "rgba(255,255,255,0.45)", textAlign: "center", marginBottom: 56, maxWidth: 420, margin: "0 auto 56px" }}>
      Books, music, short films and stories — a life told across many forms.
    </p>
  </FadeIn>
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 16, maxWidth: "900px", margin: "0 auto" }}>
    {CREATIONS.map((c, i) => (
      <FadeIn key={i} delay={i * 0.05}>
  <div className="pcard" style={{ height: "100%" }}>
  {c.img && (
    <img src={c.img} alt={c.title}
style={{ width: "100%", maxHeight: 180, objectFit: "contain", borderRadius: 10, marginBottom: 16 }}
  />
)}
  <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "2px", color: "#7c3aed", textTransform: "uppercase", marginBottom: 8 }}>{c.category}</div>
          <div className="pf" style={{ fontSize: 18, fontWeight: 700, color: "#0a0612", marginBottom: 4 }}>{c.title}</div>
          {c.subtitle && <div className="in" style={{ fontSize: 13, fontStyle: "italic", color: "#f59e0b", marginBottom: 6 }}>{c.subtitle}</div>}
          {c.meta && <div className="in" style={{ fontSize: 12, color: "#9ca3af", marginBottom: 14, lineHeight: 1.5 }}>{c.meta}</div>}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: "auto" }}>
            {c.links.map((l, j) => (
              <a key={j} href={l.href} target="_blank" rel="noreferrer"
                className="in"
                style={{
                  fontSize: 12, padding: "6px 14px", borderRadius: 6, textDecoration: "none",
                  background: j === 0 ? "linear-gradient(135deg,#4F46E5,#7C3AED)" : "rgba(124,58,237,0.08)",
                  color: j === 0 ? "white" : "#7c3aed",
                  border: j === 0 ? "none" : "1px solid rgba(124,58,237,0.2)",
                  fontWeight: 500,
                }}
              >{l.label}</a>
            ))}
          </div>
        </div>
      </FadeIn>
    ))}
  </div>
</section>

      {/* TESTIMONIALS */}
      <section style={{ padding: "88px 24px", background: "#0a0612" }}>
        <FadeIn>
          <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "3px", color: "#7c3aed", textTransform: "uppercase", textAlign: "center", marginBottom: 8 }}>Early feedback</div>
          <h2 className="pf" style={{ fontSize: 36, fontWeight: 700, color: "#0a0612", textAlign: "center", marginBottom: 48 }}>What our testers say</h2>
        </FadeIn>
        <div className="tcards" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 20, maxWidth: "860px", margin: "0 auto" }}>
          {TESTIMONIALS.map((t, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <div className="tcard">
                <p className="in" style={{ fontSize: 14, color: "#374151", lineHeight: 1.7, fontStyle: "italic", marginBottom: 16 }}>{t.quote}</p>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ ...t.av, width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 600, flexShrink: 0, fontFamily: "Inter, sans-serif" }}>{t.initials}</div>
                  <div>
                    <div className="in" style={{ fontSize: 13, fontWeight: 500, color: "#0a0612" }}>{t.name}</div>
                    <div className="in" style={{ fontSize: 11, color: "#9ca3af" }}>{t.loc}</div>
                  </div>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* EMAIL SIGNUP */}
      <section id="contact" style={{ padding: "88px 24px", background: "linear-gradient(160deg,#1a0a2e,#0d0618)", textAlign: "center" }}>
        <FadeIn>
          <h2 className="pf" style={{ fontSize: 36, fontWeight: 700, color: "white", marginBottom: 10 }}>Stay in the loop</h2>
          <p className="in" style={{ fontSize: 14, color: "rgba(255,255,255,0.4)", marginBottom: 32 }}>Be the first to hear about new products, launches & updates</p>
          {submitted ? (
            <div className="in" style={{ color: "#a78bfa", fontSize: 16 }}>🎉 Thank you! We'll be in touch.</div>
          ) : (
            <form onSubmit={handleEmail} style={{ display: "flex", gap: 10, maxWidth: 440, margin: "0 auto", flexWrap: "wrap", justifyContent: "center" }}>
              <input className="email-input" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
              <button className="email-btn" type="submit">Notify me</button>
            </form>
          )}
        </FadeIn>

        {/* Social links */}
        <FadeIn delay={0.2}>
          <div className="in" style={{ fontSize: 10, fontWeight: 600, letterSpacing: "3px", color: "rgba(255,255,255,0.3)", textTransform: "uppercase", margin: "48px 0 16px" }}>Follow STIMU</div>
          <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
            {[
              { label: "TikTok", path: "M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z" },
              { label: "Facebook", path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" },
              { label: "Instagram", path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" },
            ].map((s, i) => (
              <a key={i} className="social-btn" href="#">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d={s.path} /></svg>
                {s.label}
              </a>
            ))}
            {/* SHOP MODAL */}

          </div>
        </FadeIn>
      </section>

      {/* FOOTER */}
      <footer style={{ padding: "32px 24px", borderTop: "1px solid rgba(255,255,255,0.06)", background: "#0a0612", textAlign: "center" }}>
        <div className="pf" style={{ fontSize: 20, fontWeight: 900, color: "white", marginBottom: 16 }}>
          STIM<span style={{ color: "#a78bfa" }}>U</span>
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 24, marginBottom: 16, flexWrap: "wrap" }}>
          {["Motoguard", "ListNgo", "Shop", "Our story", "Creations", "Contact"].map(l => (
            <span key={l} className="footer-link" onClick={() => scrollTo(l.toLowerCase().replace(" ", ""))}>{l}</span>
          ))}
          <a href="/stock" className="footer-link" style={{ color: "#C9A84C" }}>Stock footage</a>
        </div>
        <div className="in" style={{ fontSize: 11, color: "rgba(255,255,255,0.2)", letterSpacing: "0.5px" }}>
          © 2026 STIMU Trading · Built with heart in the UK · stimu.app
        </div>
      </footer>
      {/* SHOP MODAL */}
      {shopOpen && (
        <div onClick={() => setShopOpen(false)} style={{
          position: "fixed", inset: 0, zIndex: 200,
          background: "rgba(10,6,18,0.85)", backdropFilter: "blur(6px)",
          display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "white", borderRadius: 20, padding: 32,
            maxWidth: 480, width: "100%", position: "relative",
          }}>
            <button onClick={() => setShopOpen(false)} style={{
              position: "absolute", top: 16, right: 16,
              background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#6b7280",
            }}>✕</button>
            <div className="pf" style={{ fontSize: 22, fontWeight: 700, color: "#0a0612", marginBottom: 6 }}>STIMU Shop</div>
            <div className="in" style={{ fontSize: 13, color: "#9ca3af", marginBottom: 24 }}>Carefully sourced everyday essentials</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {PRODUCTS.find(p => p.isShop).shopItems.map((item, i) => (
                <div key={i} style={{
                  display: "flex", alignItems: "center", gap: 16,
                  border: "1px solid #e5e7eb", borderRadius: 14, padding: 16,
                }}>
                  <div style={{ fontSize: 32 }}>{item.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div className="pf" style={{ fontSize: 15, fontWeight: 700, color: "#0a0612", marginBottom: 4 }}>{item.name}</div>
                    <div className="in" style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>{item.desc}</div>
                    <span className="in" style={{ ...item.tagStyle, fontSize: 10, padding: "3px 10px", borderRadius: 6, fontWeight: 600 }}>{item.tag}</span>
                  </div>
                  {item.links && (
  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
    {item.links.map((l, j) => (
      <a key={j} href={l.href} target="_blank" rel="noreferrer" className="in"
        style={{
          background: j === 0 ? "linear-gradient(135deg,#0f766e,#0369a1)" : "rgba(15,118,110,0.08)",
          color: j === 0 ? "white" : "#0f766e",
          border: j === 0 ? "none" : "1px solid rgba(15,118,110,0.25)",
          fontSize: 12, fontWeight: 600,
          padding: "8px 14px", borderRadius: 8, textDecoration: "none", whiteSpace: "nowrap", textAlign: "center",
        }}>
        {l.label}
      </a>
    ))}
  </div>
)}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

    </div>
    );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/stock" element={<Stock />} />
        <Route path="/stock/success" element={<StockSuccess />} />
        <Route path="/*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
